import { ReactElement } from 'react';
import { JobMetricsContainer } from '../../../../modules/jobs/containers/details/JobMetrics.container';

export const InferenceDetailsMetricsView = (): ReactElement => <JobMetricsContainer />;
